<template>
  <div
    v-if="dialog"
    class="fixed inset-0 p-2 grid items-center text-center z-50"
    style="background: rgba(0,0,0,0.7)"
    @click.self="close()"
  >
    <div class="bg-white w-full max-w-lg mx-auto shadow-md p-6 stack rounded">
      <div class="text-xl text-left font-medium" v-if="dialog.title.length > 0">{{dialog.title}}</div>

      <div class="text-left" v-if="dialog.text.length > 0">{{dialog.text}}</div>

      <div class="text-right mt-2">
        <wd-button @input="cancel" black class>{{ cancelButtonLabel }}</wd-button>
        <wd-button
          class="ml-3"
          :warning="dialog.type === 'alert'"
          @input="submit"
          v-if="!dialog.submitHide"
          :featured="dialog.type !== 'alert'"
        >{{ submitButtonLabel }}</wd-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    close() {
      this.$store.dispatch("dialog/close");
    },
    submit() {
      this.dialog.submitFn();
      this.close();
    },
    cancel() {
      this.dialog.cancelFn();
      this.close();
    }
  },
  computed: {
    dialog() {
      return this.$store.getters["dialog/getCurrent"];
    },
    submitButtonLabel() {
      return this.dialog.getSubmitButtonLabel();
    },
    cancelButtonLabel() {
      return this.dialog.getCancelButtonLabel();
    }
  },
  created() {}
};
</script>
